/* eslint-disable */
export default {
  recentActivities: 'Attività recenti',
  text: 'SMS',
  fax: 'Fax',
  voicemail: 'Messaggio vocale',
  call: 'Chiamata',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
